export const ConsoleTemplateIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 2C13.7015 2 14 2.29848 14 2.66667V13.3333C14 13.7015 13.7015 14 13.3333 14H2.66667C2.29848 14 2 13.7015 2 13.3333V2.66667C2 2.29848 2.29848 2 2.66667 2H13.3333ZM7.33333 8.66667H3.33333V12.6667H7.33333V8.66667ZM8.66667 12.6667H12.6667V3.33333H8.66667V12.6667ZM7.33333 3.33333H3.33333V7.33333H7.33333V3.33333Z"
      fill="currentColor"
    />
  </svg>
);

export default ConsoleTemplateIcon;
